export default __webpack_public_path__ + "static/media/stETH.1cc18714.svg";